import type { ExpenseItem } from '@/services/api/expense'
import type { DriveCopyStatus } from '@/types/expense'

export const driveCopyState = (expenses: ExpenseItem[]): DriveCopyStatus | null => {
  const statuses = expenses
    .map((expense) => expense.google_drive_status)
    .filter((status): status is DriveCopyStatus => status !== null)

  if (statuses.length === 0) return null
  if (statuses.includes('failed')) return 'failed'
  if (statuses.includes('pending')) return 'pending'

  return 'uploaded'
}

export const pendingCopyCount = (expenses: ExpenseItem[]) =>
  expenses.filter((expense) => expense.google_drive_status === 'pending').length
